export default __webpack_public_path__ + "f9cf64b9be722b7bf6dc5a603960c33e.png";